import React from 'react';
import { FileTextOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { theme } from '../utils/theme';

const { Title, Text } = Typography;

const MedicalRecords = () => (
  <div style={{ textAlign: 'center', padding: '40px 0' }}>
    <FileTextOutlined style={{ fontSize: '64px', color: theme.primaryBlue, marginBottom: '16px' }} />
    <Title level={4}>Medical Records Module</Title>
    <Text type="secondary" style={{ maxWidth: '500px', margin: '0 auto' }}>
      Access and manage patient medical history, test results, and treatment plans.
    </Text>
  </div>
);

export default MedicalRecords;